import {
  Body,
  Button,
  Sheet,
  SheetClose,
  SheetContent,
  SheetTrigger,
} from '@e2n/ui/v2';
import { Navigation } from '@/domain/mitarbeiter/features/anlageassistent/components/Navigation';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';

function Header() {
  const { ctx } = useAnlageassistentContext();
  const currentStep = ctx.state.steps[ctx.state.currentStepIndex];

  return (
    <div className="flex gap-1">
      <Body weight="semibold">{currentStep.title}</Body>
      {currentStep.type === 'step' && (
        <Body className="text-neutrals-700 ">
          {`${ctx.state.currentSubStepIndex + 1} von ${currentStep.subSteps.length > 0 ? currentStep.subSteps.length : 1}`}
        </Body>
      )}
      <FontAwesomeIcon
        icon={faChevronDown}
        className="size-4 text-neutrals-700 md:hidden"
      />
    </div>
  );
}

function MobileHeaderWrapper() {
  return (
    <Sheet>
      <SheetTrigger className="md:hidden">
        <Header />
      </SheetTrigger>
      <SheetContent side="left" className="px-4">
        <div className="h-16 flex items-center justify-end">
          <SheetClose asChild>
            <Button iconOnly variant="ghost">
              <FontAwesomeIcon icon={faXmark} />
            </Button>
          </SheetClose>
        </div>
        <Navigation />
      </SheetContent>
    </Sheet>
  );
}

export { Header, MobileHeaderWrapper };
